/* global gui */
/* global app, Push */
function AtlasNotification() {

    this.init = function() {}
    this.error = function(msg) {
        if(typeof msg === "object"){
            gui.showSnackBar(msg)
        }else{
            this.error({message: msg})
        }
    }
    
    this.info = function(msg) {
        if(typeof msg === "object"){
            gui.showSnackBar(msg)
        }else{
            this.info({message: msg})
        }
    }
    
    
    this.push = function(msg){
        Push.create("Hello world!", {
            body: msg,
            icon: 'assets/imgs/event_imgs/rbball2018.jpg',
            timeout: 4000,
            onClick: function () {
                window.focus();
                this.close();
            }
        });
    }
    
    this.init();
}

app.service('AtlasNotification', [AtlasNotification]);
